// extracted by mini-css-extract-plugin
export default {"tab-base":"tab-base_tab-base__mXYl5"};